import TncViewController from './TncViewController';

export default TncViewController;
